import React, { useEffect, useRef, useState } from "react";

// import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import MenuButton from "./MenuButton";
import Menutool from "./Menutool";
import { useTheme } from "@mui/material/styles";
import useAuth from "../../ContextProvider/AuthProvider";
import { Box } from "@mui/material";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef();
  const { partner } = useAuth();

  // let navigate = useNavigate();
  const tooltipRef = useRef();
  const theme = useTheme();
  function handleClick(event) {
    setIsOpen(!isOpen);
  }
  function handleClickOutside(event) {
    if (
      ref.current &&
      !ref.current.contains(event.target) &&
      !tooltipRef.current.contains(event.target)
    ) {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const Wrapper = styled.div`
  width: 100%;
  height: 150px;
  position: fixed;
  display: grid;
  gap: 200px;
  grid-template-columns: 10px auto;
  justify-content: space-around;
  align-items: center;
  background: ${theme.palette.primary.main};
  display: none;
  padding: 14px 0px;

  @media (max-width: 890px) {
    display: grid;
    gap: 300px;
    grid-template-columns: 10px auto;
    justify-content: space-around;
    height: 50px;
    position: relative;
  }
  @media (max-width: 350px) {
    gap: 200px;
  }
`;

const MenuWrapper = styled.div`
  align-items: center;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(8, auto);

  @media (max-width: 1130px) {
    > a {
      display: none;
    }
    grid-template-columns: auto;
  }
  .active {
    background: ${theme.palette.primary.main};
    border-radius: 10px;
    padding: 10px 15px;
  }

  a {
    text-decoration: none;
  }
`;
  return (
    <div>
      <Wrapper>
        {" "}
        {/* <img
          alt="logo"
          // onClick={() => {
          //   navigate("https://www.pawprintid.com/");
          // }}
          src={require("../../Assets/Images/Sidebar/pawprint-logo.png")}
        /> */}
         <Box component="div" sx={{maxHeight:'137px'}}>
             <Logo src={partner?.logo ? partner?.logo : require("../../Assets/Images/Sidebar/pawprint-logo.png")}/>
          </Box>
        <MenuWrapper>
          <HamburgerWrapper onClick={(event) => handleClick(event)}>
            <MenuButton
              item={{
                icon: require("../../Assets/Images/Sidebar/hamburger-menu.png"),
              }}
              padding='0px'
            />
          </HamburgerWrapper>
        </MenuWrapper>
      </Wrapper>
      <div ref={tooltipRef}></div>
      <Menutool munuRef={ref} isOpen={isOpen} setIsOpen={setIsOpen}/>
    </div>
  );
}

const HamburgerWrapper = styled.div`
  display: none;
  @media (max-width: 890px) {
    display: block;
  }
`;


const Logo = styled.img`
    height: auto;
    max-height: 137px;
`;